import type { QueryClient } from '@tanstack/vue-query';

export const growthCtaKeys = {
  all: ['growth', 'cta'] as const,
  tenant: (tenantId?: number): readonly unknown[] => [...growthCtaKeys.all, tenantId],
};

export const invalidateGrowthCtaQueries = async (queryClient: QueryClient): Promise<void> => {
  await queryClient.invalidateQueries({ queryKey: growthCtaKeys.all, exact: false });
};
